import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'

@Component({})
export default class BaseSubNav extends Vue {
  @Prop(String) title!: string
}
